import React from 'react';

import clsx from 'clsx';

import { makeStyles } from '@material-ui/core/styles';
import { Button, Typography } from '@material-ui/core';

import background from '../../assets/clouds.jpg';
import * as link from '../../utilities/link-config';

const useStyles = makeStyles((theme) => ({
    // [theme.breakpoints.up('xs')]: {}
    // [theme.breakpoints.up('sm')]: {}
    // [theme.breakpoints.up('md')]: {}
    // [theme.breakpoints.up('xl)]: {}
    root: {
        padding: theme.spacing(4),
        backgroundColor: theme.palette.common.white,
        color: theme.palette.grey[700]
    },
    content: {
        padding: theme.spacing(4),
        borderRadius: theme.spacing(1),
        width: '80%',
        margin: '0 auto',
        color: theme.palette.common.white,
        backgroundImage: `url(${background})`,
        backgroundAttachment: "fixed",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",

        [theme.breakpoints.up('xs')]: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
        },
        [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
        },
    },
    header: {
        fontWeight: 700
    },
    underline: {
        fontSize: theme.typography.h6.fontSize
    },
    question: {
        [theme.breakpoints.up('xs')]: {
            marginRight: 0,
            marginBottom: theme.spacing(1),
            textAlign: 'center'
        },
        [theme.breakpoints.up('md')]: {
            marginRight: theme.spacing(4),
            marginBottom: 0,
            textAlign: 'left'
        },
    },
    button: {
        marginTop: theme.spacing(1)
    }
}))

export default function Docs(props) {
    const classes = useStyles();

    const clicked = () => {
        window.gtag('event', 'nanomeet_docs_requested', {
            'event_callback': () => {
                window.open(link.NANOMEET_DOCS, "_blank")
            }
        })
    }

    return (
        <div className={classes.root}>
            <div className={classes.content}>
                <div className={classes.question}>
                    <Typography variant="h4" className={classes.header}>
                        You are a developer?
                    </Typography>
                    <Typography variant="body1" className={classes.underline}>
                        Browse through our docs and learn how easy it is to integrate <b>nanoMeet</b> into your web page.
                    </Typography>
                </div>
                <Button onClick={clicked} className={classes.button} size="large" color="secondary" variant="contained" >
                    Getting Started
                </Button>
            </div>
        </div>
    )
}